<div
  *ngIf="loading || loadingError"
  fxLayout="column"
  fxLayoutAlign="center center"
  class="indicator-container"
  [class.local]="local"
>
  <app-new-spinner></app-new-spinner>
  <div *ngIf="loadingError" class="text-me text-md">
    Sprawdź połączenie z Internetem<br />
    lub spróbuj ponownie później.
  </div>
</div>
